import { Dispatcher, GetStore } from '../Store';
import { Application } from '../../models/';
import { APPLICATION_CONNECTED, APPLICATION_DISCONNECTED } from '../constants.index';

export interface IApplicationActionsService {
    connect(application: Application): Dispatcher<void>;
    disconnect(): Dispatcher<void>;
}

export class ApplicationActionsService implements IApplicationActionsService {
    static serviceId = 'applicationActionsService';
    static $inject = ['$q'];

    constructor(
        private _$q: angular.IQService
    ) {
    }

    connect(application: Application): Dispatcher<void> {
        return (dispatch: Function, getState: GetStore) => {
            const defer = this._$q.defer<void>();
            dispatch({ type: APPLICATION_CONNECTED, payload: application });
            defer.resolve();
            return defer.promise;
        };
    }

    disconnect(): Dispatcher<void> {
        return (dispatch: Function, getState: GetStore) => {
            const defer = this._$q.defer<void>();
            dispatch({ type: APPLICATION_DISCONNECTED });
            defer.resolve();
            return defer.promise;
        };
    }
}